module.exports = __webpack_public_path__ + "static/media/nicolas-garcia.8cc2859e.jpg";